import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import imgDragDrop from '../../../assets/images/docs/install-dragAndDrop.png';
import installVideo from '../../../assets/video/install-touchpose.mp4';
import VideoPlayer from './VideoPlayer';
import { MenuPath, Note } from '../ui';

const GettingStartedDoc: React.FC = () => {
  const { t } = useTranslation();

  return (
    <article className="font-body text-content-primary">
      {/* -- Installation Guide -- */}
      <h2
        id="installation-guide"
        className="font-display text-[24px] font-extrabold text-content-primary mb-[24px] tracking-[-0.4px]"
      >
        {t('docs.gettingStarted.title')}
      </h2>
      <VideoPlayer src={installVideo} />

      <ol className="p-0 m-0 list-none">
        {[
          <Trans
            i18nKey="docs.gettingStarted.step1"
            components={{ code: <MenuPath>{''}</MenuPath> }}
          />,
          <>{t('docs.gettingStarted.step2')}</>,
          <Trans
            i18nKey="docs.gettingStarted.step3"
            components={{
              usec: (
                <Link
                  to="/management"
                  className="text-blue-link no-underline font-medium"
                />
              )
            }}
          />,
          <Trans
            i18nKey="docs.gettingStarted.step4"
            components={{
              usec: (
                <Link
                  to="/touchpose/docs/editor#touchpose-menu"
                  className="text-blue-link no-underline font-medium"
                />
              )
            }}
          />
        ].map((step, i) => (
          <React.Fragment key={i}>
            <li className="flex gap-[16px] mb-[20px] items-start">
              <span className="shrink-0 w-[28px] h-[28px] rounded-full bg-surface-hover border-[1.5px] border-border-brand flex items-center justify-center font-display text-[13px] font-bold text-blue-link">
                {i + 1}
              </span>
              <p className="mt-[4px] text-[14px] leading-[1.75] text-content-secondary">
                {step}
              </p>
            </li>
            {i === 0 && (
              <div className="mt-[4px] mb-[24px] ml-[44px]">
                <img
                  src={imgDragDrop}
                  alt={t('docs.gettingStarted.imgAlt')}
                  className="max-w-full w-auto rounded-[10px] border border-surface-hover shadow-[0_2px_12px_rgba(34,211,238,0.08),0_1px_4px_rgba(0,0,0,0.06)]"
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </ol>

      <Note label={t('docs.gettingStarted.noteLabel')}>
        <Trans
          i18nKey="docs.gettingStarted.note1"
          components={{
            usec: (
              <Link
                to="/touchpose/docs/maya-menu"
                className="text-blue-link no-underline font-medium"
              />
            )
          }}
        />
      </Note>
    </article>
  );
};

export default GettingStartedDoc;
